import type { FaireProductEntity } from "../../entity_types/product";

export const p_wvhdpbattq: FaireProductEntity = {
  token: "p_wvhdpbattq",
  type: "product",
  name: "Big Heart Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3cd46160909e5aaa4c80a5e9b78c018a25223600da01222c8a11872c4f90793e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee55711d6cca170b9c90ecf3d4364c2e376a87eadc1d7c8aeba4097bb085ea94.jpeg",
    "https://cdn.faire.com/fastly/454ee654a4d50469e770deb71cd88c6ed00a65a27310e21b3ebf1c73d65cc294.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:13.543Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
